<template>
  <div class="case-client-box">
    <div class="case-client-middle">
      <div class="go-back-old" @click="goBackOld">切回旧版</div>
      <div class="cc-search">
        <div class="search-input">
          <el-input v-model="params.applicantName" placeholder="申请人名称/证件号码" @keyup.enter.native="onSearch">
            <template #suffix>
              <el-icon  @click="onSearch"><Search /></el-icon>
            </template>
          </el-input>
        </div>
        <div class="add-btn" @click="onSetTemplate('')">新建模版</div>
        <div class="add-btn right" @click="exportApplicant">全部导出</div>
      </div>
      <div class="cc-content">
        <el-table :data="tableData" stripe tooltip-effect="dark" height="100%">
          <el-table-column prop="applicantName" label="申请主体" show-overflow-tooltip></el-table-column>
          <el-table-column prop="applicantTypeName" label="类型" width="80">
            <template #header>
              <div class="headerBox">
                类型
                <el-popover v-if="typeList.length > 0" placement="bottom" v-model="states.typeState" popper-class="tableHeaderFilter" trigger="click">
                  <div class="filterBox">
                    <div v-for="item in typeList" :class="item.value === params.applicantType ? 'active' : ''" class="filter-btn"
                     :key="item.value" @click="typeChange(item.value)">{{ item.label }}</div>
                  </div>
                  <template #reference>
                    <el-icon size="14"><CaretBottom /></el-icon>
                  </template>
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="bookTypeName" label="国家/地区" width="120">
            <template #header>
              <div class="headerBox">
                国家/地区
                <el-popover placement="bottom" v-model="states.areaState" popper-class="tableHeaderFilter" trigger="click">
                  <div class="filterBox">
                    <div v-for="item in areaList" :class="item.value === params.bookType ? 'active' : ''" class="filter-btn"
                      :key="item.value" @click="areaChange(item.value)">{{ item.label }}</div>
                  </div>
                  <template #reference>
                    <el-icon size="14"><CaretBottom /></el-icon>
                  </template>
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="idCard" label="证件号" show-overflow-tooltip width="170">
            <template #default="scope">
              <div>{{ scope.row.applicantType == 1 ? scope.row.creditCode : scope.row.idCard }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="extName" label="联系人" show-overflow-tooltip width="120"></el-table-column>
          <el-table-column prop="extTel" label="联系人电话" show-overflow-tooltip width="130"></el-table-column>
          <el-table-column prop="domesticReceiverEmail" label="联系人邮箱" show-overflow-tooltip></el-table-column>
          <el-table-column prop="flowStateName" label="状态" width="110">
            <template #header>
              <div class="headerBox">
                状态
                <el-popover placement="bottom" v-model="states.state" popper-class="tableHeaderFilter" trigger="click">
                  <div class="filterBox">
                    <div v-for="item in stateList" :class="item.value === params.flowState ? 'active' : ''" class="filter-btn"
                      :key="item.value" @click="stateChange(item.value)">
                      <span class="item-radius"
                        :class="item.value === 0 ? 'bg-waring' : item.value == 2 ? 'bg-success' : item.value == 3 ? 'bg-dage' : item.value == 1 || item.value == 4 ? 'bg-win' : item.value == 5 ? 'bg-gray' : ''"></span>
                      <span>{{ item.label }}</span>
                    </div>
                  </div>
                  <template #reference>
                    <el-icon size="14"><CaretBottom /></el-icon>
                  </template>
                </el-popover>
              </div>
            </template>
            <template #default="scope">
              <div v-if="scope.row.flowState == 3">
                <el-tooltip class="item" effect="dark" :content="scope.row.auditReason" placement="top-start">
                  <div class="filter-btn">
                    <span class="item-radius bg-dage"></span>
                    <span>{{ scope.row.flowStateName }}</span>
                  </div>
                </el-tooltip>
              </div>
              <div class="filter-btn" v-else>
                <span class="item-radius"
                  :class="scope.row.flowState === 0 ? 'bg-waring' : scope.row.flowState == 2 ? 'bg-success' : scope.row.flowState == 3 ? 'bg-dage' : scope.row.flowState == 1 || scope.row.flowState == 4 ? 'bg-win' : scope.row.flowState == 5 ? 'bg-gray' : ''"></span>
                <span>{{ scope.row.flowStateName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="importTime" label="操作" width="190">
            <template #default="scope">
              <div class="table-btn-box">
                <nav class="set-btn" @click="onSetTemplate(scope.row)">编 辑</nav>
                <nav class="set-btn" @click="onCopyTemplate(scope.row)">复制申请主体</nav>
                <nav @click="onDelete(scope.row)">删 除</nav>
              </div>
            </template>
          </el-table-column>
          <div slot="empty">
            <img style="width: 200px; height: 130px;" src="@/assets/img/common/tableNoData.png" alt="">
            <p>暂无数据</p>
          </div>
        </el-table>
      </div>
      <div class="cc-page">
        <Pagination :total="total" :page="params.pageNum" :limit="params.pageSize" @pagination="changePage" />
      </div>
    </div>
    <!-- 删除申请主体弹窗 -->
    <DelDialog ref="del" @onSearch="onSearch"></DelDialog>
    <!-- 编辑申请主体弹窗 -->
    <ApplicantSet ref="ApplicantSet" @onSaveApplicant="onSaveApplicant"></ApplicantSet>
    <!-- 审核不通过申请主体保存后修改订单状态 -->
    <EditSuccess ref="applicantEditSuccess" :applicantId="noPassApplicantId" :orderList="noPassOrderList" :applicantName="noPassApplicantName"></EditSuccess>
  </div>
</template>
<script>
import _validate from "@/framework/common/qds_validate";
import { getApplicantList, exportApplicantList, listIntelligentOrderNotPassByApplicant } from "@/server/applicant";
import DelDialog from "./plugin/delDialog.vue";
import ApplicantSet from "./drawer/set.vue";
import EditSuccess from "./editSuccess.vue";
import Pagination from "@/components/Pagination";
import { Common } from '@/common';
export default {
  components: { DelDialog, ApplicantSet, EditSuccess, Pagination },
  data() {
    return {
      tableData: [],
      total: 0,
      params: {
        pageNum: 1,
        pageSize: 10,
        applicantName: "",
        applicantType: "",
        bookType: "",
        flowState: "",
      },
      typeList: [
        { label: "全部", value: "" },
        { label: "企业", value: 1 },
        { label: "个人/个体工商户", value: 0 },
      ],
      areaList: [
        { label: "全部", value: "" },
        { label: "中国", value: 1 },
        { label: "海外", value: 2 },
        { label: "中国台湾", value: 3 },
        { label: "中国香港", value: 4 },
        { label: "中国澳门", value: 5 },
      ],
      stateList: [
        { label: "全部", value: "" },
        { label: "待提交", value: 0 },
        { label: "待审核", value: 1 },
        { label: "审核通过", value: 2 },
        { label: "审核不通过", value: 3 },
        { label: "暂存", value: 5 },
      ],
      states: {
        typeState: false,
        areaState: false,
        state: false
      },
      qdsUrl: '',
      userInfo: {},
      noPassApplicantId: 0,
      noPassOrderList: [],
      noPassApplicantName: ''
    };
  },

  mounted() {
    var applicantName = this.$route.query.applicantName;
    this.params.applicantName = applicantName ? applicantName : '';
    this.init();
    this.qdsUrl = process.env.VUE_APP_QDS_URL;
    this.userInfo = JSON.parse(decodeURIComponent(Common.getCookie("QDS_LOGIN_INFO_OFFICE") ? Common.getCookie("QDS_LOGIN_INFO_OFFICE") : "{}"));
  },

  methods: {
    // 初始化数据
    init() {
      this.getApplicantList();
    },
    // 申请主体管理 列表
    async getApplicantList() {
      let self = this;
      let res = await getApplicantList(self.params);
      self.total = res.total;
      self.tableData = res.list;
    },
    // 导出申请主体列表
    async exportApplicant() {
      if (this.total < 1) {
        this.$message.error('无可导出数据')
        return
      }
      let res = await exportApplicantList(this.params);
    },
    // 新建/编辑模板
    onSetTemplate(row) {
      this.$refs.ApplicantSet.init(row ? row.applicantIde : '')
    },
    // 复制模板
    onCopyTemplate(row) {
      this.$refs.ApplicantSet.init(row ? row.applicantIde : '', 1)
    },
    // 翻页监测
    changePage(val) {
      let self = this;
      this.params.pageNum = val.page;
      this.params.pageSize = val.limit;
      self.getApplicantList();
    },
    // 类型监测
    typeChange(val) {
      this.params.applicantType = val;
      this.states.typeState = false;
      this.onSearch();
    },
    // 国家/地区监测
    areaChange(val) {
      this.params.bookType = val;
      this.states.areaState = false;
      this.onSearch();
    },
    // 状态监测
    stateChange(val) {
      this.params.flowState = val;
      this.states.state = false;
      this.onSearch();
    },
    // 搜索
    onSearch() {
      document.body.click()
      let self = this;
      self.params.pageNum = 1;
      self.getApplicantList();
    },
    // 编辑申请主体
    onSaveApplicant(id, state, name) {
      console.log(id, state)
      this.getApplicantList();
      if (id && state == 3) {
        this.noPassApplicantId = id;
        this.noPassApplicantName = name;
        this.getNoPassOrderList();
      }
    },
    // 获取审核不通过申请主体关联订单
    async getNoPassOrderList() {
      var self = this
      let res = await listIntelligentOrderNotPassByApplicant({ applicantId: this.noPassApplicantId });
      if (res) {
        self.noPassOrderList = res;
        if (self.noPassOrderList.length > 0) {
          self.$refs.applicantEditSuccess.init();
        }
      }
    },
    // 删除
    onDelete(row) {
      this.$refs.del.init(row.applicantIde);
    },
    goBackOld() {
      window.location.href = this.qdsUrl + "/applicants/list?userIde=" + this.userInfo.userId;
    }
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
<style lang="less" scoped>
&:deep(.el-input__icon) {
  line-height: 32px;
  cursor: pointer;
}

.headerBox i {
  color: #c5c5c5;
  font-weight: 800;

  .icon-active {
    transform: rotateZ(180deg);
    color: #ff7200 !important;
  }

}

.headerBox i:hover {
  color: #c5c5c5;
}
</style>